"use strict";
window.theme = window.theme || {}
theme.quickMedalDrawer = function() {

    function quickMedalDrawer() {

        this.btn = {
            product_page: document.querySelectorAll('.product-medal-form button.medal'),
            close: document.querySelectorAll('.quick-medal-drawer .quick-medal-drawer__close'),
            overlay: document.querySelectorAll('.quick-medal-drawer .quick-medal-drawer__overlay'),
            country_label: document.querySelector('.quick-medal-drawer label[for="location"]'),
            product_handle_close: document.querySelectorAll('.quick-medal-drawer .product_medal_close'),
            info: document.querySelector('.quick-medal-drawer-input-form .decanter-text-info'),
            info_close: document.querySelector('.quick-medal-drawer-input-form .decanter-close'),
            request: document.querySelector('.medal-form-submission')
        }
        this.container = {
            quick_drawer: document.querySelector('.quick-medal-drawer'),
            country_list: document.querySelector('.quick-medal-drawer [name="medal[country]"]'),
            country_state_list: document.querySelector('.quick-medal-drawer [name="medal[state]"]'),
            confirmation: document.querySelector('.quick-medal-drawer .form-submit-status'),
            decanter_handle: document.querySelectorAll('.quick-medal-drawer .medal-form-decanter-product'),
            info: document.querySelector('.quick-medal-drawer .decanter-info'),
            state: document.querySelector('.medal-form-state'),
            post_success: document.querySelector('form.medal-form-submission .successfull-post'),
            post_error: document.querySelector('form.medal-form-submission .error-post-form'),
            success_form: document.querySelector('.quick-medal-drawer__container')
        }
        this.input = {
            firstname: document.querySelector('.quick-medal-drawer [name="medal[firstname]"]'),
            lastname: document.querySelector('.quick-medal-drawer [name="medal[lastname]"]'),
            email: document.querySelector('.quick-medal-drawer [name="medal[email]"]'),
            subject: document.querySelector('.quick-medal-drawer [name="medal[subject]"]'),
            sku: document.querySelector('.quick-medal-drawer [name="medal[sku]"]'),
            phone: document.querySelector('.quick-medal-drawer [name="medal[phone]"]'),
            decanter_code: document.querySelector('.quick-medal-drawer [name="medal[decanternumber]"]'),
            address: document.querySelector('.quick-medal-drawer [name="medal[address]"]'),
            city: document.querySelector('.quick-medal-drawer [name="medal[city]"]'),
            postcode: document.querySelector('.quick-medal-drawer [name="medal[postcode]"]'),
            country: document.querySelector('.quick-medal-drawer [name="medal[country]"]'),
            state: document.querySelector('.quick-medal-drawer [name="medal[state]"]'),
            type: document.querySelector('.quick-medal-drawer [name="medal[type]"]')
        }
        this.label = {
            decanter_code: document.querySelector('.quick-medal-drawer [for="contact_decanter_no"]'),
            address: document.querySelector('.quick-medal-drawer [for="contact_address"]'),
            city: document.querySelector('.quick-medal-drawer [for="contact_city"]'),
            postcode: document.querySelector('.quick-medal-drawer [for="contact_postcode"]'),
            country: document.querySelector('.quick-medal-drawer [for="contact_location"]'),
            state: document.querySelector('.quick-medal-drawer [for="contact_state"]'),
            confirmation_error: document.querySelector('.quick-medal-drawer .notification-error')
        }
        this.api = {
            url: null,
            loadingbar: document.querySelector('.quick-medal-drawer .api-loader'),
            spinner: document.querySelector('.quick-medal-drawer-input-form button > .spinner')
        }

        this.load();

    }
    quickMedalDrawer.prototype.load = function() {
        var _ = this; 
        _.btn.product_page.forEach(element => {
            element.addEventListener('click', () => {
                _.opendrawer('',false,'');
            })
        })
        _.btn.close.forEach(element => {
            element.addEventListener('click', () => {
                _.closedrawer();
            })
        })
        _.btn.overlay.forEach(element => {
            element.addEventListener('click', () => {
                _.closedrawer();
            })
        })
        if(_.container.country_list && _.container.country_list.length>0) {
            _.repopulatecountry();
        } 
        _.btn.product_handle_close.forEach(el => {
            el.addEventListener('click', (event) => {
                event.target.closest('button').parentElement.classList.remove('active');
            }) 
        }) 
       if(_.input.address) {
           _.input.address.addEventListener('focus', (event) => {
           _.label.address.classList.add('focus');
        })
          _.input.address.addEventListener('focusout', (event) => {
                if(event.target.value === '') {
                    _.label.address.classList.remove('focus');
                }           
            })
        }
        if(_.input.city) {
        _.input.city.addEventListener('focus', (event) => {
            _.label.city.classList.add('focus');
        })
        _.input.city.addEventListener('chance', (event) => {
            _.label.city.classList.add('focus');
        })
        _.input.city.addEventListener('focusout', (event) => {
            if(event.target.value === '') {
                _.label.city.classList.remove('focus');
            }           
        })
        }
        if(_.input.postcode) {
        _.input.postcode.addEventListener('focus', (event) => {
            _.label.postcode.classList.add('focus');
        })
        _.input.postcode.addEventListener('focusout', (event) => {
            if(event.target.value === '') {
                _.label.postcode.classList.remove('focus');
            }           
        })
        }
        if(_.input.state && _.container.state.classList.contains('active')) {
            _.input.state.addEventListener('focus', (event) => {
                _.label.state.classList.add('focus');
            })
            _.input.state.addEventListener('focusout', (event) => {
                if(event.target.value === '') {
                    _.label.state.classList.remove('focus');
                }           
            })
        }
        if(_.input.country) {
        _.input.country.addEventListener('focus', (event) => {
            _.label.country.classList.add('focus');
        })
        _.input.country.addEventListener('focusout', (event) => {
            if(event.target.value === '') {
                _.label.country.classList.remove('focus');
            }           
        })
        _.input.country.addEventListener('change', (event) => {
            if(event.target.value === 'United States of America') {
                _.container.state.classList.add('active');
                _.repopulatestate(event.target.value);
            } else {
                _.container.state.classList.remove('active');
            }          
        })
        }      
        if(_.input.decanter_code) {
        _.input.decanter_code.addEventListener('focus', (event) => {
            _.label.decanter_code.classList.add('focus');
        })
        _.input.decanter_code.addEventListener('focusout', (event) => {
            if(event.target.value === '') {
                _.label.decanter_code.classList.remove('focus');
            }           
        })
        _.input.decanter_code.addEventListener('change', (event) => {
            if(event.target.value === '') {
                _.label.decanter_code.classList.remove('focus');
            } else {
                _.label.decanter_code.classList.add('focus');
            }         
        })
        }
        if(_.btn.info) {
            _.btn.info.addEventListener('click', event => {
                _.container.info.classList.toggle('active');
            })
        }
        if(_.btn.info_close) {
            _.btn.info_close.addEventListener('click', event => {
                _.container.info.classList.toggle('active');
            })
        }
        if(_.btn.request) {
            _.btn.request.addEventListener('submit', event => {       
                if(_.input.address.value !== '' && _.input.city.value !== '' && _.input.postcode.value !== '' && _.input.country.value !== '') {
                    event.preventDefault();
                    _.request();
                    return true;
                }    
            })
        } 
        _.api.url = this.container.quick_drawer.getAttribute('data-api-url');
    }
    quickMedalDrawer.prototype.opendrawer = function(decanter_number, inputreadonly, product_handle) {
        var _ = this; 
        let scrollPosition = window.pageYOffset;
        _.container.quick_drawer.classList.add('active');
        _.container.quick_drawer.classList.add('visible');
        document.body.style.setProperty('padding-right', '6px');
        document.body.style.setProperty('overflow', 'hidden');   
        document.body.style.setProperty('position', 'fixed');  
        document.body.style.setProperty('top', `-${scrollPosition}px`);  
        document.body.style.setProperty('width', '100%');  
        if(decanter_number !=='' &&  _.input.decanter_code) {
            _.input.decanter_code.value = decanter_number;
        }        
        if(inputreadonly && _.input.decanter_code) {
            _.input.decanter_code.setAttribute('readonly','');
        } else {
            if( _.input.decanter_code)_.input.decanter_code.removeAttribute('readonly');
        }
        if(product_handle !== '') {
            _.container.decanter_handle.forEach(el => {
                if(product_handle === el.getAttribute('data-product-handle')) {
                    el.classList.add('active');
                } else {
                    el.classList.remove('active');
                }
            })
        }
    }
    quickMedalDrawer.prototype.closedrawer = function() {
        var _ = this; 
        _.container.quick_drawer.classList.remove('active');
        _.container.quick_drawer.classList.remove('visible');
        document.body.removeAttribute('style');
        _.container.post_error.classList.remove('d-none');
        _.container.post_success.classList.add('d-none');
        _.input.decanter_code.value = '';
        _.input.address.value = '';
        _.input.city.value = '';
        _.input.postcode.value = '';
        _.repopulatecountry();
        _.container.decanter_handle.forEach(el => {
            el.classList.remove('active');
        })
        _.container.state.classList.remove('active');
        _.label.address.classList.remove('focus');
        _.label.city.classList.remove('focus');
        _.label.postcode.classList.remove('focus');
        _.label.country.classList.remove('focus');
        _.label.state.classList.remove('focus');
        _.container.success_form.classList.remove('success');
        _.label.confirmation_error.textContent = '';
        _.label.confirmation_error.classList.remove('active');
        _.api.loadingbar.classList.remove('active');
    }
    quickMedalDrawer.prototype.repopulatecountry = function() {
        var _ = this;
        let country_code_default = 0;
        if(_.container.country_list && _.container.country_list.getAttribute('data-location') == null) {
            return false;
        };
        _.container.country_list.innerHTML = '<option value disabled selected hidden></option>';
        fetch(_.container.country_list.getAttribute('data-location'), {
        method: 'GET'
        })
        .then(response => {
        return response.json();
        })  
        .then(data => { 
            if(data.length>0) {
                data.forEach((country,index) => {
                let newOption = new Option(country.name, country.name);
                _.container.country_list.add(newOption,undefined);
                if(country.code === Shopify.country) {
                    country_code_default = index;
                }
                })  
                _.container.country_list.selectedIndex = country_code_default+1;     
                _.label.country.classList.add('focus'); 
               }
        })        
        .catch((error) => {
               console.error('Error:', error);
        });
    }
    quickMedalDrawer.prototype.repopulatestate = function(country) {
        var _ = this;
        if(_.container.country_state_list && _.container.country_state_list.getAttribute('data-state') == null) {
            return false;
        };
        fetch(_.container.country_state_list.getAttribute('data-state'), {
        method: 'GET'
        })
        .then(response => {
        return response.json();
        })  
        .then(data => { 
            if(data.countries.length>0) {
                _.container.country_state_list.innerHTML = '<option value disabled selected hidden></option>';
                data.countries.forEach(countrystate => {
                    if(countrystate.country === country) {
                       countrystate.states.forEach(state => {
                              let newOption = new Option(state, state);
                                 _.container.country_state_list.add(newOption,undefined);
                       })
                    }
                })              
                _.container.country_state_list.selectedIndex = 1;   
                _.label.state.classList.add('focus'); 
            } else {
                _.container.country_state_list.innerHTML = '<option value disabled selected hidden></option>';
            }
        })        
        .catch((error) => {
               console.error('Error:', error);
        });
    }    
    quickMedalDrawer.prototype.request = function() {
        var _ = this;
        _.api.spinner.classList.add('active');
        _.label.confirmation_error.textContent = "Thank you for registering your decanter. We're verifying its authenticity to ensure exclusivity to LOUIS XIII Society. Please wait a moment.";
        _.label.confirmation_error.classList.add('active');
        _.btn.overlay.forEach(el => {
            el.style.setProperty('pointer-events', 'none');
        });
        _.btn.close.forEach(el => {
            el.style.setProperty('pointer-events', 'none');
        });
        var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
        let dataJSON = {
            "medal_form": {
                "firstname": _.input.firstname.value,
                "lastname": _.input.lastname.value,
                "email": _.input.email.value,
                "phone": _.input.phone.value,
                "subject": _.input.subject.value,
                "sku": _.input.sku.value,
                "decanterno": _.input.decanter_code.value,
                "address": _.input.address.value,
                "city": _.input.city.value,
                "postcode": _.input.postcode.value,
                "country": _.input.country.value,
                "state": _.input.country.value === 'United States of America' ? _.input.state.value : 'N/A',
                "type": _.input.type.value
                }
            };
            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: JSON.stringify(dataJSON),
                redirect: 'follow'
                };

            fetch(_.api.url, requestOptions)
            .then(response => response.json())
            .then(data => {
                _.api.spinner.classList.remove('active');
                if(data.message === 'error') {
                    _.label.confirmation_error.textContent = data.errorMessage;
                    _.label.confirmation_error.classList.add('active');
                    _.container.post_error.classList.remove('d-none');
                    _.container.post_success.classList.add('d-none'); 
                    _.container.success_form.classList.remove('success');
                    _.btn.overlay.forEach(el => {
                        el.removeAttribute('style');
                    });
                    _.btn.close.forEach(el => {
                        el.removeAttribute('style');
                    });
                } 
                if(data.message ==='success') {
                    dataLayer.push({
                        'event': 'request_medal_form'
                    });
                    _.label.confirmation_error.textContent = data.successMessage;
                    _.label.confirmation_error.classList.remove('active');
                    _.container.post_error.classList.add('d-none');
                    _.container.post_success.classList.remove('d-none');
                    _.container.success_form.classList.add('success');
                    _.btn.overlay.forEach(el => {
                        el.removeAttribute('style');
                    });
                    _.btn.close.forEach(el => {
                        el.removeAttribute('style');
                    });
                }                            
            })
            .catch(error => {
                _.label.confirmation_error.textContent = 'The server encountered an internal error or misconfiguration and was unable to complete your request. Please try again after few minutes.';
                _.label.confirmation_error.classList.add('active');
                _.api.spinner.classList.remove('active');
                console.log('error', error)
                _.btn.overlay.forEach(el => {
                    el.removeAttribute('style');
                });
                _.btn.close.forEach(el => {
                    el.removeAttribute('style');
                });
            });
    }

  theme.quickMedalDrawer = new quickMedalDrawer;

}

theme.quickMedalDrawer();